import * as Sentry from "@sentry/react";
import { Protected } from "@stardeck-customer-apps/project-auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { AdminLogin } from "@/pages/admin-login";
import { Cars } from "@/pages/cars";
import { Customers } from "@/pages/customers";
import { Home } from "@/pages/home";
import { Inventory } from "@/pages/inventory";
import { NotFound } from "@/pages/not-found";
import { Pipeline } from "@/pages/pipeline";
import { Tasks } from "@/pages/tasks";
import { Unauthorized } from "@/pages/unauthorized";
import { VehicleListing } from "@/pages/vehicle-listing";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <Routes>
              {/* Public Routes - No authentication required */}
              <Route path="/cars" element={<Cars />} />
              <Route path="/listing/:id" element={<VehicleListing />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/unauthorized" element={<Unauthorized />} />

              {/* Protected CRM Routes - Admin authentication required */}
              <Route
                path="/"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/admin/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <Home />
                  </Protected>
                }
              />
              <Route
                path="/customers"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/admin/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <Customers />
                  </Protected>
                }
              />
              <Route
                path="/customers/:id"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/admin/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <Customers />
                  </Protected>
                }
              />
              <Route
                path="/pipeline"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/admin/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <Pipeline />
                  </Protected>
                }
              />
              <Route
                path="/inventory"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/admin/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <Inventory />
                  </Protected>
                }
              />
              <Route
                path="/tasks"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/admin/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <Tasks />
                  </Protected>
                }
              />

              {/* Catch-all */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Sentry.ErrorBoundary>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
